import { Component } from '@angular/core';
import { BaseComponent } from '../../../../../../base/base.component';

@Component({
  selector: 'app-wiki-editor-bottom-toolbar',
  templateUrl: './wiki-bottom-toolbar.component.html',
  styleUrl: './wiki-bottom-toolbar.component.scss',
  standalone: false,
})
export class WikiEditorBottomToolbarComponent extends BaseComponent {}
